import React, { useEffect, useState } from 'react';
import styles from './NewsCard.module.scss';
import InfoButton from '../../Atoms/InfoButton/InfoButton';
import togglerGreen from '../../../assets/Imagess/toggler-green.svg';
import deleteSvg from '../../../assets/icons/formActions/delete.svg';
import downloadIcon from '../../../assets/Imagess/download.svg';
import DeletePopup from '../Custom/DeletePopup';
import EventInfoModal from './EventInfoModal';
import RenameMediaModal from './RenameMediaModal';
import closeIcon from '../../../assets/Imagess/close-white.svg';
import backIcon from '../../../assets/Imagess/arrow-circle-left.svg';
import backIconRight from '../../../assets/Imagess/arrow-circle-right.svg';
import downloadWhite from '../../../assets/Imagess/download-white.svg';
import trashWhite from '../../../assets/Imagess/trash-white.svg';
import { useToast } from '../Custom/CustomToaster/Toast';
import { useDeleteMediaImage } from '../../../Hooks/Media';
import { sanitizeAndValidateUrl } from '../../../app/helpers/sanitizeAndValidateUrl';

function GalleryItem({
  media,
  refetchMedia,
  mediaImages,
  currentIndex,
  setCurrentIndex,
  index,
}) {
  const [showInfo, setShowInfo] = useState(false);
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [toggled, setToggled] = useState(false);
  const [expandedImage, setExpandedImage] = useState(
    media?.url + media?.imageURL
  );
  const [extension, setExtension] = useState('');
  const customizedToast = useToast();
  const {
    mutate: deleteImage,
    isLoading: isDeletingImage,
    isSuccess,
  } = useDeleteMediaImage(media?.mediaGalleryDetailsId);

  useEffect(() => {
    if (isSuccess) {
      setShowDeletePopup(false);
      setToggled(false);
      customizedToast.open('تم الحذف بنجاح');
      refetchMedia();
    }
  }, [isSuccess]);

  const handleDownload = () => {
    const sanitizedUrl = sanitizeAndValidateUrl(
      `${media?.url}${media?.imageURL}`
    );
    window.open(sanitizedUrl, '_blank');
  };

  const handleNext = () => {
    const nextIndex = (currentIndex + 1) % mediaImages.length;
    setCurrentIndex(nextIndex);
    const nextMedia = mediaImages[nextIndex];
    setExpandedImage(
      sanitizeAndValidateUrl(nextMedia?.url + nextMedia?.imageURL)
    );
    setExtension(nextMedia.imageURL.split('.').pop().split(/\#|\?/)[0]);
  };

  const handlePrevious = () => {
    const prevIndex =
      (currentIndex - 1 + mediaImages.length) % mediaImages.length;
    setCurrentIndex(prevIndex);
    const prevMedia = mediaImages[prevIndex];
    setExpandedImage(
      sanitizeAndValidateUrl(prevMedia?.url + prevMedia?.imageURL)
    );
    setExtension(prevMedia.imageURL.split('.').pop().split(/\#|\?/)[0]);
  };

  useEffect(() => {
    if (media?.imageURL) {
      const getFileExtension = (url) => {
        return url.split('.').pop().split(/\#|\?/)[0];
      };
      const ext = getFileExtension(media.imageURL);
      setExtension(ext);
    }
  }, [media]);

  useEffect(() => {
    setExpandedImage(sanitizeAndValidateUrl(media?.url + media?.imageURL));
  }, [currentIndex]);

  const menuItems = [
    {
      label: 'تنزيل',
      icon: downloadIcon,
      onClick: handleDownload,
    },
    {
      label: 'حذف',
      icon: deleteSvg,
      onClick: () => {
        setShowDeletePopup(true);
      },
    },
  ];

  return (
    <>
      {toggled && (
        <div className={styles['toggled-view']}>
          <div className={styles['control-container']}>
            <img
              src={trashWhite}
              onClick={() => setShowDeletePopup(true)}
              className={styles['cursor-pointer']}
            />
            <img
              src={downloadWhite}
              onClick={handleDownload}
              className={styles['cursor-pointer']}
            />
            <img
              src={closeIcon}
              onClick={() => setToggled(false)}
              className={styles['cursor-pointer']}
            />
          </div>
          <div className={styles['image-container']}>
            <img
              src={backIcon}
              onClick={handlePrevious}
              className={styles.arrow}
            />
            {extension === 'mp4' ? (
              <video
                src={expandedImage}
                controls
                className={styles['video-expanded']}
                onClick={() => setToggled(true)}
                autoPlay
                loop
                playsInline
                muted
              />
            ) : (
              <img
                src={expandedImage}
                onClick={() => setToggled(true)}
                className={styles['zoomed-image']}
              />
            )}

            <img
              src={backIconRight}
              onClick={handleNext}
              className={styles.arrow}
            />
          </div>
        </div>
      )}
      <div
        className={`${styles['news-card']}`}
        style={{
          position: 'relative',
          borderRadius: '28px',
        }}
      >
        <div style={{ position: 'absolute', top: 24, right: 24 }}></div>
        <div className={styles['media-image-container']}>
          <InfoButton
            icon={togglerGreen}
            className={styles['more-info']}
            data={menuItems}
            white={true}
            left
          />
          {extension === 'mp4' ? (
            <video
              src={expandedImage}
              className={styles['zoomed-video']}
              onClick={() => setToggled(true)}
              height={200}
              autoPlay
              loop
              playsInline
              muted
            />
          ) : (
            <img
              src={expandedImage}
              className={styles['news-card-image']}
              style={{
                borderRadius: '28px',
                cursor: 'auto',
                cursor: 'pointer',
              }}
              onClick={() => setToggled(true)}
            />
          )}
        </div>
        {showDeletePopup && (
          <DeletePopup
            handleOnClose={() => setShowDeletePopup(false)}
            title="صورة"
            handleDelete={() => {
              deleteImage();
              refetchMedia();
            }}
            isLoading={isDeletingImage}
          />
        )}
        {showInfo && (
          <EventInfoModal
            event={media}
            handleOnClose={() => setShowInfo(false)}
          />
        )}
        {showRenameModal && (
          <RenameMediaModal
            media={media}
            handleOnClose={() => setShowRenameModal(false)}
            refetchMedia={refetchMedia}
          />
        )}
      </div>
    </>
  );
}

export default GalleryItem;
